// @flow

const apiKey = process.env.SEGMENT_API_KEY || "";

export default apiKey;
